import { render, staticRenderFns } from "./SearchNews.vue?vue&type=template&id=5edbb52f&scoped=true&"
import script from "./SearchNews.vue?vue&type=script&lang=js&"
export * from "./SearchNews.vue?vue&type=script&lang=js&"
import style0 from "./SearchNews.vue?vue&type=style&index=0&id=5edbb52f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edbb52f",
  null
  
)

export default component.exports